// third party libs
import React, { useState, useCallback, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

//piggybank
import IconExport from '@piggybank/core/components/Icon/wrapped-icons/IconExport';
import IconUser from '@piggybank/core/components/Icon/wrapped-icons/IconUser';

// mws common ui
import withNLS from '@sgp/compat/shared/HOC/withNLS';

//styles and NLS
import styles from './styles.pcss';
import nls from './nls/strings_nls';

// local components
import { ChevronDown } from '@sgp-common/components/Page/Icon';
import { sessionClear } from '@sgp/lib/util/utilities';
import { useDspContext } from '@sgp/views/Context';
import { agentDetails } from '@sgp/lib/api';
import { ePortalLog } from '@sgp/lib/util/log/Tools';

const Myaccount = ({ NLS }) => {
  
  const [isShowMyProfileSet, setShowMyProfile] = useState(false);
  const [agentBasicInfo, setAgentBasicInfo] = useState({});
  const myAccountRef = useRef(null);
  const { dsptoken, dspTokenDispatch } = useDspContext();
  const agentBusinessInfo = dsptoken?.agentInfo?.agentBusinessInfo || {};
  const contextAgentInfo = dsptoken?.agentInfo || {};

  const showMyProfile = useCallback(() => {
    setShowMyProfile({ 'isShowMyProfileSet': !isShowMyProfileSet.isShowMyProfileSet });
  }, [isShowMyProfileSet]);

  useEffect(() => {
    document.addEventListener('click', handleMyAccountOutSideClick);
    return () => {
      document.removeEventListener('click', handleMyAccountOutSideClick);
    };
  }, []);

  const retrieveAgentDetails = async () => {
    try {
      sessionStorage.setItem('headerType', 'AGENTINFO');
      const agentDetail = await (agentDetails());                
      if(agentDetail?.agentBasicInfo) {
        let myAgentBusinessInfo = ({ 
          firstName: agentDetail?.agentBasicInfo?.firstName,
          lastName: agentDetail?.agentBasicInfo?.lastName,
          id: btoa(agentDetail?.agentBasicInfo?.agentUniqueID),
          jadeAgentNumber: agentDetail?.agentBusinessInfo?.jadeAgentNumber,
          lifeAgentNumber: agentDetail?.agentBusinessInfo?.lifeAgentNumber,
          email: agentDetail?.agentBusinessInfo?.userName,
        });
        dspTokenDispatch({ type: 'setAgentInfo', payload: { agentInfo: myAgentBusinessInfo } });
        setAgentBasicInfo(myAgentBusinessInfo);

      }
    } catch (e) {
      ePortalLog("[E]", e);
    }
  }

  useEffect(() => {
      // `email` is part of the guard as well, otherwise an advisor whose ODS record
      // has no first/last name would re-fetch get_user_profile on every mount.
      if (contextAgentInfo?.firstName || contextAgentInfo?.lastName || contextAgentInfo?.email) {
        setAgentBasicInfo(contextAgentInfo);
      } else {
        retrieveAgentDetails();
      }
  }, [contextAgentInfo?.firstName, contextAgentInfo?.lastName, contextAgentInfo?.email]);


  const handleMyAccountOutSideClick = useCallback((e) => {
    if (myAccountRef.current?.contains(e.target)) { return; }
    setShowMyProfile({ isShowMyProfileSet: false });
  }, []);

  const showHideBox = { display: (isShowMyProfileSet.isShowMyProfileSet ? 'flex' : 'none') };

  // Only join the parts that actually came back, so a missing first or last name
  // never renders the literal string "undefined". Fall back to the email address
  // when the profile carries no name at all.
  const displayName =
    [agentBasicInfo?.firstName, agentBasicInfo?.lastName].filter(Boolean).join(' ') ||
    agentBasicInfo?.email ||
    '';

  const logout = () => {
    sessionClear();
    dspTokenDispatch({ type: 'settoken', payload: { value: '' } });
  };

  return (
    <>
      <div className={styles.Userbox} onClick={() => showMyProfile()} ref={myAccountRef} tabIndex="0">
        <IconUser />
        <span className={styles.Username}>{ displayName }</span>
        <span><ChevronDown /></span>
        <ul style={showHideBox} id="myAcnt">
          <li className={styles.Active}><Link to="/myprofile"><IconUser width={'1.425em'} /><span>{NLS`myProfile`}</span></Link></li>
          <li onClick={() => logout()}><Link to="/logout"><IconExport width={'1.425em'} /><span>{NLS`logout`}</span></Link></li>
        </ul>
      </div>
    </>
  );
};

export default withNLS(nls)(Myaccount);
